var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2808 13.2808C16.133 12.8989 18.3327 10.456 18.3327 7.49935C18.3327 4.27769 15.721 1.66602 12.4993 1.66602C9.54267 1.66602 7.09976 3.86574 6.71791 6.71791M13.3327 12.4993C13.3327 15.721 10.721 18.3327 7.49935 18.3327C4.27769 18.3327 1.66602 15.721 1.66602 12.4993C1.66602 9.27769 4.27769 6.66602 7.49935 6.66602C10.721 6.66602 13.3327 9.27769 13.3327 12.4993Z",
    stroke: "#EBEBF5",
    strokeOpacity: 0.64,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpot);
export default __webpack_public_path__ + "static/media/spot.58095bbaa6f7c1f97338b4548966b251.svg";
export { ForwardRef as ReactComponent };